import * as React from 'react';
import Typography from '@mui/material/Typography';

type DigitalStylingOrderCustomerInProgressProps = {
    text: string;
};

export function DigitalStylingOrderCustomerInProgress({
    text
}: DigitalStylingOrderCustomerInProgressProps) {
    return (
        <fieldset>
            <Typography sx={{ padding: '20px 20px 10px 20px' }} variant="body1">
                {text}
            </Typography>
        </fieldset>
    );
}
